export enum LookupEventType {
  UPDATE,
  BATCH_UPDATE,
  DELETE,
  ERROR,
  NOTIFICATION,
  ORDER_ENTRY,
  DETAIL_FILL,
  ORDER_ENTRY_CLEAR,
  DELETE_WITH_REASON,
}

export namespace LookupEventType {
  let elements = [
    LookupEventType.UPDATE,
    LookupEventType.BATCH_UPDATE,
    LookupEventType.DELETE,
    LookupEventType.ERROR,
    LookupEventType.NOTIFICATION,
    LookupEventType.ORDER_ENTRY,
    LookupEventType.DETAIL_FILL,
    LookupEventType.ORDER_ENTRY_CLEAR,
  ];
  let alias = "com.bcdfx.model.LookupEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
